// @flow
import type { Auction } from './types'
import type { Item } from '../item/types'
import type { Warnings } from '../mycharity/auction/types'
import findKey from 'lodash/findKey'
import { isItemCompleted } from '../item/utils'
import { AUCTION_STATE } from './constants'
import { validateTime } from '../validations/validations'

export const isAuctionClosed = (auction: Auction): boolean =>
  auction && auction.state === AUCTION_STATE.CLOSED

export const isAuctionLive = (auction: Auction): boolean =>
  auction && auction.state === AUCTION_STATE.LIVE

export const isAuctionPending = (auction: Auction): boolean =>
  auction && auction.state === AUCTION_STATE.PENDING

export const isAuctionDraft = (auction: Auction): boolean =>
  auction && auction.state === AUCTION_STATE.DRAFT

export const isAuctionPublished = (auction: Auction): boolean =>
  isAuctionPending(auction) || isAuctionLive(auction)

export const isAuctionInfoCompleted = (auction: Auction): boolean => {
  const {
    title,
    startTime,
    closeTime,
    category,
    description,
    location
  } = auction
  return Boolean(
    title && startTime && closeTime && category && description && location
  )
}

export const isAuctionOptionsCompleted = (auction: Auction): boolean => {
  const { shippingOption, pickUpAtEvent, pickUpAtEventMaxTime } = auction
  const isTimeCorrect = pickUpAtEvent
    ? !validateTime(pickUpAtEventMaxTime)
    : true
  return Boolean(shippingOption && isTimeCorrect)
}

export const hasAuctionItemsCompleted = (auctionItems: Item[]): boolean =>
  Array.isArray(auctionItems) &&
  Boolean(auctionItems.find(item => isItemCompleted(item)))

export const hasAuctionWarnings = (warnings: Warnings): boolean =>
  Boolean(findKey(warnings, err => err === true))



// WEBPACK FOOTER //
// ./src/services/auction/utils.js